export const codeAndTestcaseLocalstorageKey = '__CDH_TDD_CTC__';
export const accessTokenKey = '__CDH_TDD_AT__';

export const apiConfig = {
  baseUrl: {
    dev: 'http://localhost:5556',
    prod: 'http://api.suhari.codedoh.com',
  },
};

export const levelList = [
  { value: '10', label: 'Warm up' },
  { value: '20', label: 'Challenge' },
  { value: '30', label: 'Head-banging' },
];

export const kataType = {
  ALL: 'all',
  MY: 'my',
};

export const htmlSummaryRange = [20, 60];
